import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from '../../shared';
import { DashboardComponent } from './dashboard.component';
import { DashboardRewardsSummaryComponent } from './dashboard-rewards-summary/dashboard-rewards-summary.component';
import { DashboardSalesChallengesComponent } from './dashboard-sales-challenges/dashboard-sales-challenges.component';
import { DashboardActivityChallengesComponent } from './dashboard-activity-challenges/dashboard-activity-challenges.component';
import { DashboardSellerFilterComponent } from './dashboard-seller-filter/dashboard-seller-filter.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
  ],
  declarations: [
    DashboardComponent,
    DashboardRewardsSummaryComponent,
    DashboardSalesChallengesComponent,
    DashboardActivityChallengesComponent,
    DashboardSellerFilterComponent,
  ],
  exports: [
    DashboardComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA,
  ],
})
export class DashboardModule { }
